export default "__VITE_ASSET__L30hc45G__"